$('document').ready(() => {
    $('.comments__list-item-actions-comment-number').click((e) => {
        let parentComment = $(e.target).parents('.comments__list-item');
        let innerComments = parentComment.find('.comments__list-item-inner-list');
        $('.comments__list-item-actions-comment-number').toggleClass('comments__list-item-actions-comment-number--active');
        innerComments.slideToggle();
    })
    $('.comments__list-item-actions-make').click((e) => {
        let parentComment = $(e.target).parents('.comments__list-item');
        let answerForm = parentComment.find('.comments__list-item-inner-answer');
        answerForm.slideToggle();
    })
})
